import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { RecommenderManagementComponent } from './recommender-management.component';
import { RecommenderService } from '@fuse/services/recommender/recommender.service';
import { MatIconModule, MatButtonModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatSnackBarModule, MatSelectModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RecommenderListComponent } from './recommender-list/recommender-list.component';
import { RecommenderFormDialogComponent } from './recommender-form/recommender-form.component';
import { TelInputModule } from '@fuse/components/tel-input/tel-input.module';

const routes = [
    {
        path: 'recommender',
        component: RecommenderManagementComponent

    }
];

@NgModule({
    declarations: [
        RecommenderManagementComponent,
        RecommenderListComponent,
        RecommenderFormDialogComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatSnackBarModule,
        MatSelectModule,
        MatTooltipModule,
        TelInputModule
    ],
    providers: [
        RecommenderService
    ],
    exports: [
        RecommenderManagementComponent
    ]
    ,
    entryComponents: [
        RecommenderFormDialogComponent
    ]
})

export class RecommenderManagementModule {
}
